import ReactGA from "react-ga4";

export function notifyPageView(pageName: string, pageLocation: string) {
	if (process.env.NODE_ENV !== "development") {
		ReactGA.send({
			hitType: "pageview",
			page: pageLocation,
			title: pageName,
		});
	}
}
